import './PolicyStyles.css'; // Adjust path as needed
import { exportToWord } from '../utils/exportToWord';

const CustomerServicePolicy = ({
  clientName,
  clientAddress,
  effectiveDate,
   companyNumber,
  customerServiceContact,
  complaintContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Customer_Service_Policy.docx");
  };

  return (
    <div className="policy-container">
      <h3 className="policy-title">Accident & Incident Management Policy</h3>
      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> { companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">Purpose</h4>
      <p className="section-content">
        To provide outstanding customer service by ensuring all customers are treated with respect, professionalism, and efficiency. We strive to meet customer needs and handle complaints promptly and fairly.
      </p>

      <h4 className="section-title">Scope</h4>
      <p className="section-content">
        This policy applies to all employees and contractors who interact with customers or represent the company.
      </p>

      <h4 className="section-title">Responsibilities</h4>
      <p className="section-content"><strong>All Employees:</strong> Provide courteous, knowledgeable, and timely service.</p>
      <p className="section-content"><strong>Customer Service Team:</strong> Handle inquiries, complaints, and feedback professionally and escalate issues when necessary.</p>
      <p className="section-content"><strong>Management:</strong> Ensure staff are trained, supported, and that customer service standards are upheld.</p>

      <h4 className="section-title">Customer Interaction</h4>
      <ul>
        <li>Respond promptly to customer enquiries via phone, email, or in person.</li>
        <li>Maintain clear and honest communication.</li>
        <li>Respect customer privacy and confidentiality.</li>
        <li>Listen actively and empathize with customer concerns.</li>
      </ul>

      <h4 className="section-title">Handling Complaints</h4>
      <ul>
        <li>All complaints must be logged and acknowledged within 24 hours.</li>
        <li>Investigate complaints thoroughly and objectively.</li>
        <li>Provide clear resolution and feedback to the customer.</li>
        <li>Escalate unresolved issues to senior management.</li>
      </ul>

      <h4 className="section-title">Continuous Improvement</h4>
      <p className="section-content">
        Regularly review customer feedback and complaints to improve service delivery and customer satisfaction.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <ul>
        <li><strong>Customer Service Contact:</strong> {customerServiceContact || "[Insert Contact Number]"}</li>
        <li><strong>Complaints Contact:</strong> {complaintContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I have read, understood, and agree to comply with the Customer Service Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is hereby in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default CustomerServicePolicy;
